import React, { useEffect, useState } from 'react'
import './App.css'
import { createTheme, CssBaseline, Grid, ThemeProvider } from '@mui/material'
import { Route, Routes } from 'react-router-dom'
import { AuthTokenContext } from './contexts/AuthTokenContext'
import { UserInfoContext } from './contexts/UserInfoContext'
import Header from './layoutComponents/Header'
import routes from '../configs/routes.js'
import SideNavBar from './layoutComponents/SideNavBar'
import loginService from '../services/loginService'
import { SnackbarProvider } from 'notistack'
import { NotificationContext } from './contexts/NotificationContext'
import { SearchBarContext } from './contexts/SearchBarContext'

const App = () => {
  const darkTheme = createTheme({
    palette: {
      mode: 'dark'
    }
  })

  const [authToken, setAuthToken] = useState(undefined)
  const [userInfo, setUserInfo] = useState(undefined)
  const [unreadNotificationCount, setUnreadNotificationCount] = useState()
  const [communityId, setCommunityId] = useState(undefined)

  const logoutHandler = () => {
    setAuthToken(undefined)
    loginService.deleteToken()
    setUserInfo(undefined)
    loginService.deleteUser()
  }

  useEffect(() => {
    setAuthToken(loginService.getToken())
    setUserInfo(JSON.parse(loginService.getUser()))
  }, [authToken])

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <AuthTokenContext.Provider value={{ authToken, setAuthToken }}>
        <UserInfoContext.Provider value={{ userInfo, setUserInfo }}>
          <NotificationContext.Provider value={{ unreadNotificationCount, setUnreadNotificationCount }}>
            <SnackbarProvider maxSnack={4} autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
              <SearchBarContext.Provider value={{ communityId, setCommunityId }}>
                <Grid container>
                  <Grid item xs={12}>
                    <Header onLogout={logoutHandler} />
                  </Grid>
                  <Grid container>
                    <Grid item xs="auto" sx={{ display: { xs: 'none', lg: 'block' } }}>
                      <SideNavBar />
                    </Grid>
                    <Grid item xs sx={{ pl: 2, pr: 2 }}>
                      <Routes>
                        {routes.map(route => <Route key={route.path} path={route.path} element={route.element}/>)}
                      </Routes>
                    </Grid>
                  </Grid>
                </Grid>
              </SearchBarContext.Provider>
            </SnackbarProvider>
          </NotificationContext.Provider>
        </UserInfoContext.Provider>
      </AuthTokenContext.Provider>
    </ThemeProvider>
  )
}

export default App
